import { fromJS, Record } from 'immutable';

export default Record({
    companyId: null,
    id: null,
    metadata: '',
    pivot: fromJS({
        primary: null,
        sort: null,
    }),
    title: '',
    type: '',
    url: '',
});



// WEBPACK FOOTER //
// ./src/records/medium.js